import React from 'react';
import InputField from "../input/InputField";
import { useTranslation } from 'react-i18next';

const DynamicListSection = ({
  title, items, onAdd, onRemove, onUpdate, addButtonLabel, fields
}) => {
  const { t } = useTranslation();
  return (
    <section className="mb-8">
      <h2 className="text-xl font-semibold text-darkGray mb-6">{title}</h2>

      <div className="space-y-6">
        {items.map((item, index) => (
          <div key={item.id} className="p-4 bg-lightGray rounded-xl border border-secondary relative">

            {items.length > 1 && (
              <button
                type="button"
                onClick={() => onRemove(index)}
                className="absolute top-2 right-2 text-xs hover:underline font-medium"
              >
                 {t('FORM.LINKS.REMOVE')}
              </button>
            )}

            <div className="space-y-4">
              {fields.map((fieldConfig) => (
                <InputField
                  key={fieldConfig.key}
                  label={fieldConfig.label}
                  type={fieldConfig.type || "text"}
                  placeholder={fieldConfig.placeholder}
                  value={item[fieldConfig.key]}
                  onChange={(e) => onUpdate(index, fieldConfig.key, e.target.value)}
                />
              ))}
            </div>
          </div>
        ))}
      </div>

      <button
        type="button"
        onClick={onAdd}
        className="mt-4 text-primary text-sm font-medium hover:text-primary flex items-center gap-1"
      >
        {addButtonLabel}
      </button>
    </section>
  );
};

export default DynamicListSection;